import { createUseStyles } from 'react-jss';
import CrossImage from '../../assets/Icon.svg';

export default createUseStyles(
  {
    root: {
      position: 'relative',
      width: '32px',
      height: '32px',
      margin: 0,
      padding: 0,
    },

    deleteIcon: {
      position: 'absolute',
      left: '25%',
      right: '25%',
      top: '25%',
      bottom: '25%',
      backgroundImage: `url(${CrossImage})`,
    },
  },
  {
    name: 'Cross',
  },
);
